// import React, { useEffect, useState, useRef } from "react";
// import { Loginwrapper } from "../style";
// import Input from "../../ui/Input";
// import Button from "../../ui/Button";
// import OtpInput from "../../OtpInput/OtpInput";
// import imgLogin from "../../../images/loginImg.png";
// import imgLogin2 from "../../../images/loginBanner.jpg";
// import { FaRupeeSign, FaCity } from "react-icons/fa";
// import { FaMoneyBillWave, FaSmile } from "react-icons/fa";
// import { motion } from "framer-motion";
// import rightImage from "../../../images/instant_loan.jpg";
// import verificationIcon from "../../../images/banner.png";

// import {
//   FaRocket,
//   FaUsers,
//   FaLightbulb,
//   FaCheckCircle,
//   FaShieldAlt,
//   FaMobileAlt,
//   FaClock,
// } from "react-icons/fa";
// import { GiReceiveMoney, GiArchiveResearch } from "react-icons/gi";
// import {
//   getStorage,
//   isEmpty,
//   isNumber,
//   setStorage,
//   getStoredUTM,
// } from "../../../Utils/common";
// import { Link, useNavigate } from "react-router-dom";
// import {
//   sendotpForLogin,
//   verifyotpForLogin,
//   ckeckEligibility,
// } from "../../../Utils/api";
// import Alert from "../../ui/Alert";
// import MobileInput from "../../OtpInput/MobileInput";

// function Login() {
//   const [otp, setOtp] = useState(["", "", "", ""]);
//   const [screen, setScreen] = useState("getOtp");
//   const [seconds, setSeconds] = useState(0);
//   const [mobile, setMobile] = useState([
//     "",
//     "",
//     "",
//     "",
//     "",
//     "",
//     "",
//     "",
//     "",
//     "",
//   ]);
//   const [mobileError, setMobileError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [accept, setAccept] = useState(false);
//   const [acceptError, setAcceptError] = useState("");
//   const [message, setMessage] = useState({});
//   const [responce, setResponce] = useState({});
//   const inputRefs = useRef([]);
//   const navigate = useNavigate();
//   const [showMore, setShowMore] = useState(false);

//   // Extract UTM parameters from the URL
//   const getUtmParams = () => {
//     const params = new URLSearchParams(window.location.search);
//     const utm = getStoredUTM();
//     return {
//       utm_source:
//         params.get("utm_source") || utm?.utm_source || utm?.referrer || "",
//       utm_medium: params.get("utm_medium") || utm?.utm_medium || "",
//       utm_campaign: params.get("utm_campaign") || utm?.utm_campaign || "",
//       utm_term: params.get("utm_term") || utm?.utm_term || "",
//       utm_content: params.get("utm_content") || utm?.utm_content || "",
//     };
//   };

//   useEffect(() => {
//     if (screen === "getOtp") return;
//     const timer = setInterval(() => {
//       if (seconds === 0) {
//         clearInterval(timer);
//       } else {
//         setSeconds(seconds - 1);
//       }
//     }, 1000);

//     return () => {
//       clearInterval(timer);
//     };
//   }, [seconds]);

//   const onChanges = (e, type) => {
//     const { name, value } = e.target;

//     if (type === "sendOtp") {
//       if (!isNumber(value) && !isEmpty(value)) return;
//       setMobile(value);
//       setMobileError("");
//     }
//   };

//   const sendOtp = () => {
//     let mobileNumber = mobile.join("");
//     if (mobileNumber.length < 10) {
//       setMobileError(
//         "The Mobile field must be at least 10 characters in length.",
//       );
//       return;
//     }
//     if (!accept) {
//       setAcceptError(
//         "Please check the checkbox to accept our terms and conditions",
//       );
//       return;
//     } else {
//       setAcceptError("");
//     }

//     // Get UTM parameters from the URL
//     const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } =
//       getUtmParams();

//     const param = {
//       mobile: mobileNumber,
//       event_name: "login",
//       utm_source,
//       utm_medium,
//       utm_campaign,
//       utm_term,
//       utm_content,
//     };

//     setLoading(true);
//     sendotpForLogin(param).then((resp) => {
//       setLoading(false);
//       if (resp?.data?.Status === 1) {
//         setResponce(resp?.data);
//         setStorage("mobile", mobileNumber);
//         setStorage("cust_profile_id", resp?.data?.Data?.cust_profile_id);
//         setScreen("otpScreen");
//         setSeconds(30);
//         setMessage({
//           type: "success",
//           msg: resp?.data?.Message,
//           place: "globle",
//         });
//       } else {
//         setMobile(["", "", "", "", "", "", "", "", "", ""]);
//         if (inputRefs.current[0]) {
//           inputRefs.current[0].focus();
//         }
//         let msg =
//           resp?.data?.Message || resp?.data?.error || "An error occurred";
//         setMessage({ type: "error", msg: msg });
//       }
//     });
//   };

//   const resendOtp = () => {
//     const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } =
//       getUtmParams();

//     const param = {
//       profile_id: getStorage("cust_profile_id"),
//       event_name: "resend_otp",
//       utm_source,
//       utm_medium,
//       utm_campaign,
//       utm_term,
//       utm_content,
//     };

//     setLoading(true);
//     sendotpForLogin(param).then((resp) => {
//       setLoading(false);
//       if (resp?.data?.Status === 1) {
//         setResponce(resp?.data);
//         setScreen("otpScreen");
//         setSeconds(30);
//         setMessage({
//           type: "success",
//           msg: resp?.data?.Message,
//           place: "globle",
//         });
//       } else {
//         setMobile(["", "", "", "", "", "", "", "", "", ""]);
//         if (inputRefs.current[0]) {
//           inputRefs.current[0].focus();
//         }
//         let msg =
//           resp?.data?.Message || resp?.data?.error || "An error occurred";
//         setMessage({ type: "error", msg: msg });
//       }
//     });
//   };

//   const verifyOTP = async () => {
//     let otpNumber = otp.join("");

//     if (otpNumber.length !== 4) {
//       setMessage({ type: "error", msg: "Please enter 4 digits OTP" });
//       return;
//     }

//     const param = {
//       event_name: "otp_verify",
//       profile_id: getStorage("cust_profile_id"),
//       otp: otpNumber,
//     };

//     setLoading(true);
//     try {
//       const resp = await verifyotpForLogin(param);

//       setLoading(false);

//       if (resp?.data?.Status === 1) {
//         setResponce(resp?.data);
//         setStorage("next_step", resp?.data?.Data?.next_step);
//         setStorage("token", resp?.data?.Data?.app_login_token);
//         setMessage({
//           type: "success",
//           msg: resp?.data?.Message,
//           place: "globle",
//         });

//         if (resp?.data?.Data?.eligibility_status === 1) {
//           setStorage("eligibility", 1); // Store eligibility as 1 if eligible
//         } else {
//           setStorage("eligibility", 0); // Store eligibility as 0 if not eligible
//         }

//         // Navigate based on eligibility
//         if (getStorage("eligibility") === 1) {
//           console.log("Navigating to /my-dashboard/eligibility");
//           navigate("/my-dashboard/eligibility");
//         } else {
//           console.log("Navigating to /my-dashboard");
//           navigate("/my-dashboard");
//         }
//       } else {
//         setOtp(["", "", "", ""]);
//         if (inputRefs.current[0]) {
//           inputRefs.current[0].focus();
//         }
//         let msg =
//           resp?.data?.Message || resp?.data?.error || "An error occurred";
//         setMessage({ type: "error", msg: msg });
//       }
//     } catch (err) {
//       setLoading(false);
//       setMessage({ type: "error", msg: "Error verifying OTP" });
//       console.error("OTP Verification Error:", err);
//     }
//   };

//   const handleKeyDown = (event) => {
//     if (event.key === "Enter") {
//       event.preventDefault();
//       verifyOTP();
//     }
//   };

//   useEffect(() => {
//     if (isEmpty(message)) return;
//     const timer = setTimeout(() => {
//       setMessage({});
//     }, 5000);

//     return () => {
//       clearTimeout(timer);
//     };
//   }, [message]);

//   useEffect(() => {
//     const counters = document.querySelectorAll(".counter");
//     counters.forEach((counter) => {
//       const updateCount = () => {
//         const target = +counter.getAttribute("data-target");
//         const count = +counter.innerText.replace(/,/g, "");
//         const increment = target / 200;
//         if (count < target) {
//           counter.innerText = Math.ceil(count + increment).toLocaleString();
//           setTimeout(updateCount, 20);
//         } else {
//           counter.innerText = target.toLocaleString();
//         }
//       };
//       updateCount();
//     });
//   }, []); // empty dependency -> run once on mount
//   const cardVariants = {
//     hiddenLeft: { opacity: 0, x: -100 },
//     hiddenRight: { opacity: 0, x: 100 },
//     visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
//   };

//   const [showScroll, setShowScroll] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 600) {
//         setShowScroll(true);
//       } else {
//         setShowScroll(false);
//       }
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <>
//       {/* <Loginwrapper className="flex"> */}
//       {/* <div className="left">
//           <img src={imgLogin2} alt="" />
//           <div className="textBox">
//             <h2>
//               Need an <br /> instant loan
//             </h2>
//             <div>Up to ₹100,000</div>
//           </div>
//         </div> */}
//       {/* <div
//           className="bg-white right max-w-[413] min-h-[417] rounded-full"
//         >
//           <div className="form" style={{ maxWidth: "400px" }}>
//             <Alert setMessage={setMessage} message={message} />
//             <h2 style={{ fontSize: "26px" }}>Apply for a Personal Loan</h2>
//             {screen === "getOtp" ? (
//               <>
//                 <p className="text-black"
//                 >
//                   Enter your 10 digit mobile number to get started
//                 </p>
//                 <div className="otpBox">
//                   <MobileInput
//                     name="mobile"
//                     setOtp={setMobile}
//                     otp={mobile}
//                     isDisable={false}
//                     error={mobileError}
//                     onChange={(e) => onChanges(e, "sendOtp")}
//                     placeholder="_"
//                     onKeyDown={handleKeyDown}
//                     inputRefs={inputRefs}
//                   />
//                 </div>
//                 <div
//                   className="flex confirm"
//                   style={{
//                     fontSize: "13px",
//                     fontWeight: "600",
//                     textAlign: "justify",
//                   }}
//                 >
//                   <input
//                     style={{
//                       height: "15px",
//                       marginRight: "10px",
//                     }}
//                     name="radio"
//                     type="checkbox"
//                     checked={accept}
//                     onChange={() => {
//                       setAccept(!accept);
//                       setAcceptError("");
//                     }}
//                   />
//                   <p className="text-gray-500">
//                     By selecting this checkbox, I authorize the receipt of
//                     digital communications
//                     {showMore ? (
//                       <span>
//                         , such as phone calls, SMS, emails, and WhatsApp
//                         messages, at the phone number, email address, and app I
//                         have provided from Speedoloan. Furthermore, I
//                         acknowledge that I have reviewed and accept the ,{" "}
//                         <Link to="/termsandconditions">
//                           Terms and Conditions
//                         </Link>{" "}
//                         and <Link to="/privacypolicy"> Privacy Policy</Link>.
//                       </span>
//                     ) : (
//                       <span>
//                         <button
//                           onClick={() => setShowMore(true)}
//                           style={{
//                             cursor: "pointer",
//                             border: "none",
//                             background: "none",
//                             color: "#4FA0FF",
//                             textDecoration: "none",
//                           }}
//                         >
//                           read more
//                         </button>
//                       </span>
//                     )}
//                   </p>
//                 </div>
//                 {acceptError && (
//                   <p style={{ color: "red", fontSize: "12px" }}>
//                     {acceptError}
//                   </p>
//                 )}
//                 <div className="button">
//                   <Button
//                     title="Send OTP"
//                     onClick={sendOtp}
//                     loading={loading}
//                   />
//                 </div>
//               </>
//             ) : (
//               <>
//                 <p
//                   style={{
//                     fontSize: "15px",
//                     fontWeight: "600",
//                     marginBottom: "18px",
//                   }}
//                 >
//                   Mobile number : ******
//                   {getStorage("mobile") && getStorage("mobile").length >= 10
//                     ? getStorage("mobile").slice(-4)
//                     : "N/A"}
//                 </p>
//                 <p>Please enter the OTP to unlock your next step.</p>
//                 <div className="otpBox">
//                   <OtpInput
//                     type="text"
//                     setOtp={setOtp}
//                     otp={otp}
//                     isDisable={false}
//                     placeholder="*"
//                     onKeyDown={handleKeyDown}
//                     inputRefs={inputRefs}
//                   />
//                 </div>
//                 <div className="button">
//                   <Button
//                     title="Verify OTP"
//                     onClick={verifyOTP}
//                     loading={loading}
//                   />
//                 </div>
//                 <div className="resend">
//                   {seconds > 0 ? (
//                     <p className="none">
//                       Didn't receive the OTP?{" "}
//                       <FontAwesomeIcon
//                         icon={faClock}
//                         style={{
//                           marginRight: "5px",
//                           marginLeft: "5px",
//                           color: "red",
//                         }}
//                       />{" "}
//                       <span style={{ color: "red", fontWeight: 600 }}>
//                         00:{seconds}s
//                       </span>
//                     </p>
//                   ) : (
//                     <button
//                       onClick={!loading ? resendOtp : () => { }}
//                       style={{
//                         backgroundColor: "transparent",
//                         border: "1px solid #4FA0FF",
//                         color: "#4FA0FF",
//                         padding: "10px 9px",
//                         borderRadius: "25px",
//                         cursor: "pointer",
//                         fontSize: "13px",
//                         fontFamily: "Roboto, sans-serif",
//                         transition: "background-color 0.3s, color 0.3s",
//                       }}
//                       onMouseEnter={(e) => {
//                         e.target.style.backgroundColor = "#4FA0FF";
//                         e.target.style.color = "#fff";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.backgroundColor = "transparent";
//                         e.target.style.color = "#4FA0FF";
//                       }}
//                     >
//                       Resend OTP
//                     </button>
//                   )}
//                 </div>
//               </>
//             )}
//           </div>
//         </div> */}
//       {/* </Loginwrapper> */}
//       {/* <Loginwrapper className="relative min-h-screen w-full flex items-center justify-center">
//         {/* Background Video - SAME
//         <video
//           autoPlay
//           loop
//           muted
//           playsInline
//           className="absolute inset-0 w-full h-full object-cover"
//           src="/videos/bg.mp4"
//         />

//         {/* Dark Overlay
//         <div className="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>

//         {/* MAIN JOINED CARD
//         <div
//           className="
//       relative z-10 w-full max-w-5xl
//       grid grid-cols-1 md:grid-cols-2
//       bg-white/10 backdrop-blur-2xl
//       border border-white/20
//       rounded-3xl shadow-2xl overflow-hidden
//     "
//         >
//           {/* LEFT IMAGE SECTION
//           <div className=" md:block relative">
//             <img
//               src={rightImage}
//               alt="Loan Illustration"
//               className="w-full h-full object-cover"
//             />
//             <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent"></div>
//           </div>

//           {/* RIGHT FORM SECTION – DARKER & ALIGNED
//           <div
//             className="
//     p-5 md:p-10 text-white
//     bg-white/5 backdrop-blur-xl
//     border border-white/10
//     shadow-2xl
//     relative overflow-hidden
//     flex flex-col items-center justify-start
//   "
//           >
//             {/* Decorative Gradient Overlay *
//             <div className="absolute inset-0 bg-gradient-to-br from-black/20 to-transparent pointer-events-none"></div>

//             {/* TOP ICON *
//             <div
//               className="
//       w-20 h-20 rounded-full
//       bg-blue-500/20 border border-blue-400/30
//       flex items-center justify-center
//       mb-6 backdrop-blur-xl shadow-lg
//     "
//             >
//               <img
//                 src={verificationIcon}
//                 alt="verification"
//                 className="w-22 h-12 object-contain"
//               />
//             </div>

//             {/* Heading
//             <div className="text-3xl font-bold mb-2 tracking-wide text-center">
//               <span className="text-white">Apply for</span>
//               <span className="text-[#4FA0FF]"> Personal Loan</span>
//             </div>

//             <p className="text-gray-200 text-sm text-center max-w-xs mb-6 leading-relaxed">
//               Verify your mobile number to continue the quick loan process.
//             </p>

//             <Alert setMessage={setMessage} message={message} />

//             {/* GET OTP
//             {screen === "getOtp" ? (
//               <>
//                 <label className="text-gray-300 text-sm mb-2 block w-full text-left">
//                   Enter Mobile Number
//                 </label>

//                 <div
//                   className="
//         rounded-2xl  mb-4 flex items-center text-[white] w-full shadow-inner [&_input]:text-white
//     [&_input::placeholder]:text-white/50
//       "
//                 >
//                   <MobileInput
//                     className="otp-text"
//                     name="mobile"
//                     setOtp={setMobile}
//                     otp={mobile}
//                     error={mobileError}
//                     isDisable={false}
//                     onChange={(e) => onChanges(e, "sendOtp")}
//                     placeholder="_"
//                     onKeyDown={handleKeyDown}
//                     inputRefs={inputRefs}
//                   />
//                 </div>

//                 {/* Checkbox
//                 <label className="flex items-start gap-3 cursor-pointer w-full">
//                   {/* CHECKBOX WRAPPER (prevents movement)
//                   <span className="flex-shrink-0 mt-1">
//                     <input
//                       type="checkbox"
//                       checked={accept}
//                       onChange={() => {
//                         setAccept(!accept);
//                         setAcceptError("");
//                       }}
//                       className="
//         h-5 w-5
//         appearance-none
//         rounded-md
//         border-2 border-blue-400
//         bg-transparent
//         checked:bg-blue-500 checked:border-blue-500
//         focus:outline-none
//         transition-colors
//       "
//                     />
//                   </span>

//                   {/* TEXT CONTENT
//                   <span className="text-gray-300 text-sm leading-relaxed">
//                     I authorize communication for verification.
//                     {showMore ? (
//                       <>
//                         <br />I accept the{" "}
//                         <Link
//                           to="/termsandconditions"
//                           className="text-blue-400 underline"
//                           onClick={(e) => e.stopPropagation()}
//                         >
//                           Terms
//                         </Link>{" "}
//                         &{" "}
//                         <Link
//                           to="/privacypolicy"
//                           className="text-blue-400 underline"
//                           onClick={(e) => e.stopPropagation()}
//                         >
//                           Privacy Policy
//                         </Link>
//                         .
//                       </>
//                     ) : (
//                       <button
//                         type="button"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           setShowMore(true);
//                         }}
//                         className="text-blue-300 underline ml-1 bg-[transparent] border-none"
//                       >
//                         read more
//                       </button>
//                     )}
//                   </span>
//                 </label>

//                 {acceptError && (
//                   <p className="text-red-400 text-xs mt-2">{acceptError}</p>
//                 )}

//                 <Button
//                   className="
//           w-full py-3 mt-6 rounded-xl
//           bg-gradient-to-r from-blue-500 to-blue-600
//           text-white font-semibold
//           shadow-xl shadow-blue-500/30
//           hover:opacity-90 transition-all
//         "
//                   title="Send OTP"
//                   onClick={sendOtp}
//                   loading={loading}
//                 />
//               </>
//             ) : (
//               <>
//                 {/* OTP SCREEN *
//                 <p className="text-gray-200 text-sm mb-1 text-center">
//                   OTP sent to ******{getStorage("mobile")?.slice(-4)}
//                 </p>

//                 <p className="text-gray-300 mb-4 text-sm text-center">
//                   Enter the 4-digit verification code.
//                 </p>

//                 <div
//                   className="

//         rounded-2xl px-4 py-5 mb-4
//         shadow-inner w-full text-center
//       "
//                 >
//                   <OtpInput
//                     type="text"
//                     setOtp={setOtp}
//                     otp={otp}
//                     isDisable={false}
//                     placeholder="*"
//                     onKeyDown={handleKeyDown}
//                     inputRefs={inputRefs}
//                   />
//                 </div>

//                 <Button
//                   className="
//           w-full py-3 mt-2 rounded-xl
//           bg-gradient-to-r from-blue-500 to-blue-600
//           text-white font-semibold
//           shadow-xl shadow-blue-500/30
//           hover:opacity-90 transition-all
//         "
//                   title="Verify OTP"
//                   onClick={verifyOTP}
//                   loading={loading}
//                 />

//                 <div className="mt-4 text-gray-300 text-sm text-center">
//                   {seconds > 0 ? (
//                     <p>
//                       Resend in{" "}
//                       <span className="text-red-400 font-medium">
//                         00:{seconds}s
//                       </span>
//                     </p>
//                   ) : (
//                     <button
//                       className="text-blue-400 underline bg-[transparent]  border-none"
//                       onClick={!loading ? resendOtp : () => {}}
//                     >
//                       Resend OTP
//                     </button>
//                   )}
//                 </div>
//               </>
//             )}
//           </div>
//         </div>
//       </Loginwrapper> */}
//       <Loginwrapper className="relative min-h-screen w-full flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#F8FAF5] via-white to-[#F0F7F3]">
//         {/* Floating Waves - Top */}
//         <div className="absolute top-0 left-0 w-full pointer-events-none">
//           <svg
//             className="w-full h-48 md:h-64"
//             viewBox="0 0 1440 300"
//             preserveAspectRatio="none"
//           >
//             <motion.path
//               animate={{
//                 d: [
//                   "M0,150 C300,225 600,75 900,150 C1200,225 1440,75 1440,150 L1440,0 L0,0 Z",
//                   "M0,195 C300,120 600,270 900,195 C1200,120 1440,270 1440,195 L1440,0 L0,0 Z",
//                   "M0,150 C300,225 600,75 900,150 C1200,225 1440,75 1440,150 L1440,0 L0,0 Z",
//                 ],
//               }}
//               transition={{ duration: 12, repeat: Infinity }}
//               fill="#105840"
//               fillOpacity="0.05"
//             />
//           </svg>
//         </div>

//         {/* Floating Waves - Middle */}
//         <div className="absolute inset-0 pointer-events-none">
//           <svg
//             className="w-full h-full"
//             viewBox="0 0 1440 800"
//             preserveAspectRatio="none"
//           >
//             <motion.path
//               animate={{
//                 d: [
//                   "M0,400 C400,350 800,450 1200,400 C1600,350 2000,450 2400,400 L2400,800 L0,800 Z",
//                   "M0,450 C400,400 800,500 1200,450 C1600,400 2000,500 2400,450 L2400,800 L0,800 Z",
//                 ],
//               }}
//               transition={{ duration: 18, repeat: Infinity }}
//               fill="#105840"
//               fillOpacity="0.03"
//             />
//           </svg>
//         </div>

//         {/* Floating Waves - Bottom */}
//         <div className="absolute bottom-0 left-0 w-full pointer-events-none">
//           <svg
//             className="w-full h-48 md:h-64 rotate-180"
//             viewBox="0 0 1440 300"
//             preserveAspectRatio="none"
//           >
//             <motion.path
//               animate={{
//                 d: [
//                   "M0,150 C300,225 600,75 900,150 C1200,225 1440,75 1440,150 L1440,0 L0,0 Z",
//                   "M0,195 C300,120 600,270 900,195 C1200,120 1440,270 1440,195 L1440,0 L0,0 Z",
//                 ],
//               }}
//               transition={{ duration: 12, repeat: Infinity }}
//               fill="#105840"
//               fillOpacity="0.05"
//             />
//           </svg>
//         </div>

//         {/* Floating Green Orbs */}
//         <div className="absolute inset-0 pointer-events-none">
//           <motion.div
//             animate={{
//               y: [0, -40, 0],
//               x: [0, 30, 0],
//               scale: [1, 1.2, 1],
//             }}
//             transition={{ duration: 25, repeat: Infinity }}
//             className="absolute top-20 left-[5%] w-96 h-96 bg-[#105840]/5 rounded-full blur-3xl"
//           />
//           <motion.div
//             animate={{
//               y: [0, 40, 0],
//               x: [0, -30, 0],
//               scale: [1, 1.3, 1],
//             }}
//             transition={{ duration: 22, repeat: Infinity }}
//             className="absolute bottom-20 right-[5%] w-[500px] h-[500px] bg-[#105840]/5 rounded-full blur-3xl"
//           />
//         </div>

//         {/* MAIN CARD */}
//         <motion.div
//           initial={{ opacity: 0, y: 30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//           className="
//       relative z-30 w-full max-w-5xl
//       grid grid-cols-1 md:grid-cols-2
//       bg-white
//       border border-[#105840]/20
//       rounded-3xl shadow-2xl overflow-hidden
//     "
//         >
//           {/* LEFT SECTION - Apply for Loan Image */}
//           <div className="hidden md:block relative overflow-hidden bg-gradient-to-br from-[#105840] to-[#0A4A30]">
//             {/* Background Pattern */}
//             <div className="absolute inset-0 opacity-10">
//               <svg
//                 className="w-full h-full"
//                 viewBox="0 0 100 100"
//                 preserveAspectRatio="none"
//               >
//                 <defs>
//                   <pattern
//                     id="grid"
//                     x="0"
//                     y="0"
//                     width="20"
//                     height="20"
//                     patternUnits="userSpaceOnUse"
//                   >
//                     <circle cx="10" cy="10" r="2" fill="white" />
//                   </pattern>
//                 </defs>
//                 <rect width="100" height="100" fill="url(#grid)" />
//               </svg>
//             </div>

//             {/* Floating Waves inside left section */}
//             <div className="absolute inset-0 opacity-20">
//               <svg
//                 className="w-full h-full"
//                 viewBox="0 0 1440 800"
//                 preserveAspectRatio="none"
//               >
//                 <motion.path
//                   animate={{
//                     d: [
//                       "M0,400 C300,500 600,300 900,400 C1200,500 1440,300 1440,400 L1440,800 L0,800 Z",
//                       "M0,450 C300,350 600,550 900,450 C1200,350 1440,550 1440,450 L1440,800 L0,800 Z",
//                     ],
//                   }}
//                   transition={{ duration: 15, repeat: Infinity }}
//                   fill="white"
//                   fillOpacity="0.1"
//                 />
//               </svg>
//             </div>

//             <div className="relative z-10 h-full flex flex-col items-center justify-center p-8 text-white">
//               {/* Main Illustration - Apply for Loan */}
//               <motion.div
//                 initial={{ scale: 0.8, opacity: 0 }}
//                 animate={{ scale: 1, opacity: 1 }}
//                 transition={{ delay: 0.3, duration: 0.8 }}
//                 className="relative mb-8"
//               >
//                 {/* Document Stack */}
//                 <motion.div
//                   animate={{ y: [0, -5, 0] }}
//                   transition={{ duration: 4, repeat: Infinity }}
//                   className="relative w-64 h-64"
//                 >
//                   {/* Paper 1 */}
//                   <motion.div
//                     animate={{ rotate: [-2, 2, -2] }}
//                     transition={{ duration: 5, repeat: Infinity }}
//                     className="absolute top-0 left-0 w-56 h-40 bg-white/20 backdrop-blur-md rounded-xl border border-white/30 shadow-xl"
//                   >
//                     <div className="p-4">
//                       <div className="w-16 h-3 bg-white/30 rounded-full mb-3"></div>
//                       <div className="w-24 h-3 bg-white/30 rounded-full mb-2"></div>
//                       <div className="w-20 h-3 bg-white/30 rounded-full"></div>
//                     </div>
//                   </motion.div>

//                   {/* Paper 2 */}
//                   <motion.div
//                     animate={{ rotate: [3, -3, 3] }}
//                     transition={{ duration: 5, repeat: Infinity, delay: 0.2 }}
//                     className="absolute top-4 left-4 w-56 h-40 bg-white/20 backdrop-blur-md rounded-xl border border-white/30 shadow-xl"
//                   >
//                     <div className="p-4">
//                       <div className="w-20 h-4 bg-[#105840]/50 rounded-full mb-3"></div>
//                       <div className="w-28 h-3 bg-white/30 rounded-full mb-2"></div>
//                       <div className="w-16 h-3 bg-white/30 rounded-full"></div>
//                     </div>
//                   </motion.div>

//                   {/* Paper 3 - Top */}
//                   <motion.div
//                     animate={{ rotate: [-1, 1, -1] }}
//                     transition={{ duration: 4, repeat: Infinity, delay: 0.4 }}
//                     className="absolute top-8 left-8 w-56 h-40 bg-white backdrop-blur-md rounded-xl border border-white/30 shadow-2xl"
//                   >
//                     <div className="p-4">
//                       <div className="flex items-center gap-2 mb-3">
//                         <div className="w-8 h-8 bg-[#105840] rounded-lg"></div>
//                         <div className="w-24 h-4 bg-[#105840]/30 rounded-full"></div>
//                       </div>
//                       <div className="w-32 h-3 bg-gray-200 rounded-full mb-2"></div>
//                       <div className="w-28 h-3 bg-gray-200 rounded-full mb-2"></div>
//                       <div className="w-24 h-3 bg-gray-200 rounded-full"></div>

//                       {/* Checkmark */}
//                       <motion.div
//                         animate={{ scale: [1, 1.2, 1] }}
//                         transition={{ duration: 2, repeat: Infinity }}
//                         className="absolute bottom-4 right-4 w-8 h-8 bg-green-500 rounded-full flex items-center justify-center"
//                       >
//                         <span className="text-white text-sm">✓</span>
//                       </motion.div>
//                     </div>
//                   </motion.div>
//                 </motion.div>

//                 {/* Floating Icons */}
//                 <motion.div
//                   animate={{ y: [0, -10, 0] }}
//                   transition={{ duration: 3, repeat: Infinity }}
//                   className="absolute -top-6 -right-6 w-12 h-12 bg-yellow-400/20 backdrop-blur-sm rounded-xl border border-yellow-400/30 flex items-center justify-center"
//                 >
//                   <span className="text-2xl">💰</span>
//                 </motion.div>

//                 <motion.div
//                   animate={{ y: [0, 10, 0] }}
//                   transition={{ duration: 3.5, repeat: Infinity }}
//                   className="absolute -bottom-4 -left-4 w-10 h-10 bg-blue-400/20 backdrop-blur-sm rounded-xl border border-blue-400/30 flex items-center justify-center"
//                 >
//                   <span className="text-xl">⚡</span>
//                 </motion.div>
//               </motion.div>

//               {/* Text Content */}
//               <motion.div
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 transition={{ delay: 0.6 }}
//                 className="text-center"
//               >
//                 <h3 className="text-2xl font-bold mb-2">
//                   Apply for Personal Loan
//                 </h3>
//                 <p className="text-white/80 text-sm max-w-xs">
//                   Quick approval • Minimal documentation • Instant disbursal
//                 </p>
//               </motion.div>

//               {/* Feature Tags */}
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.8 }}
//                 className="flex flex-wrap gap-2 justify-center mt-6"
//               >
//                 {["✓ Instant Approval", "✓ Zero Collateral", "✓ Paperless"].map(
//                   (feature, i) => (
//                     <motion.span
//                       key={i}
//                       whileHover={{ scale: 1.05 }}
//                       className="px-3 py-1 bg-white/10 backdrop-blur-sm rounded-full text-white text-xs border border-white/20"
//                     >
//                       {feature}
//                     </motion.span>
//                   ),
//                 )}
//               </motion.div>
//             </div>
//           </div>

//           {/* RIGHT FORM SECTION */}
//           <div
//             className="
//         p-8 md:p-10 text-gray-900
//         bg-white
//         relative overflow-hidden
//         flex flex-col items-center
//       "
//           >
//             {/* Decorative Green Elements */}
//             <div className="absolute -top-20 -right-20 w-60 h-60 bg-[#105840]/5 rounded-full blur-3xl"></div>
//             <div className="absolute -bottom-20 -left-20 w-60 h-60 bg-[#105840]/5 rounded-full blur-3xl"></div>

//             {/* Green Line Above Heading */}
//             <div className="flex items-center gap-3 mb-6 w-full">
//               <motion.div
//                 initial={{ width: 0 }}
//                 animate={{ width: "40px" }}
//                 transition={{ duration: 0.8 }}
//                 className="h-1 bg-[#105840] rounded-full"
//               />
//               <span className="text-xs font-medium text-[#105840] tracking-wider">
//                 LOAN APPLICATION
//               </span>
//             </div>

//             {/* Icon */}
//             <motion.div
//               initial={{ scale: 0 }}
//               animate={{ scale: 1 }}
//               transition={{ type: "spring", stiffness: 200, delay: 0.2 }}
//               className="
//           w-20 h-20 rounded-2xl
//           bg-gradient-to-br from-[#105840] to-[#0A4A30]
//           flex items-center justify-center
//           mb-6 shadow-lg shadow-[#105840]/30
//         "
//             >
//               <img
//                 src={verificationIcon}
//                 alt="verification"
//                 className="w-12 h-12 object-contain brightness-0 invert"
//               />
//             </motion.div>

//             {/* Heading */}
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.3 }}
//               className="text-center mb-6"
//             >
//               <h2 className="text-2xl md:text-3xl font-bold mb-2">
//                 <span className="text-gray-900">Apply for</span>
//                 <span className="text-[#105840] block mt-1">Personal Loan</span>
//               </h2>
//               <p className="text-gray-500 text-sm">
//                 Verify your mobile number to continue
//               </p>
//             </motion.div>

//             <Alert setMessage={setMessage} message={message} />

//             {/* GET OTP */}
//             {screen === "getOtp" ? (
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.5 }}
//                 className="w-full space-y-5"
//               >
//                 <div className="space-y-2">
//                   <label className="text-sm font-medium text-gray-700 block">
//                     Mobile Number
//                   </label>
//                   <div className="relative">
//                     <div className="absolute left-4 top-1/2 -translate-y-1/2 text-[#105840] font-medium">
//                       +91
//                     </div>
//                     <input
//                       type="tel"
//                       value={mobile}
//                       onChange={(e) => {
//                         const value = e.target.value
//                           .replace(/\D/g, "")
//                           .slice(0, 10);
//                         setMobile(value);
//                       }}
//                       placeholder="Enter 10 digit mobile number"
//                       className="w-full pl-16 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:border-[#105840] focus:ring-1 focus:ring-[#105840] transition-all outline-none"
//                       maxLength={10}
//                     />
//                   </div>
//                   {mobileError && (
//                     <p className="text-red-500 text-sm">{mobileError}</p>
//                   )}
//                 </div>

//                 {/* Terms Checkbox */}
//                 <label className="flex items-start gap-3 cursor-pointer group">
//                   <span className="flex-shrink-0 mt-1">
//                     <input
//                       type="checkbox"
//                       checked={accept}
//                       onChange={() => {
//                         setAccept(!accept);
//                         setAcceptError("");
//                       }}
//                       className="
//                   h-5 w-5
//                   appearance-none
//                   rounded-md
//                   border-2 border-gray-300
//                   bg-white
//                   checked:bg-[#105840] checked:border-[#105840]
//                   focus:outline-none focus:ring-2 focus:ring-[#105840]/50
//                   transition-all
//                   group-hover:border-[#105840]
//                 "
//                     />
//                   </span>

//                   <span className="text-gray-600 text-sm leading-relaxed">
//                     I authorize communication for verification.
//                     {showMore ? (
//                       <>
//                         <br />I accept the{" "}
//                         <Link
//                           to="/termsandconditions"
//                           className="text-[#105840] hover:text-[#0A4A30] transition-colors font-medium"
//                         >
//                           Terms
//                         </Link>{" "}
//                         &{" "}
//                         <Link
//                           to="/privacypolicy"
//                           className="text-[#105840] hover:text-[#0A4A30] transition-colors font-medium"
//                         >
//                           Privacy Policy
//                         </Link>
//                         .
//                       </>
//                     ) : (
//                       <button
//                         type="button"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           setShowMore(true);
//                         }}
//                         className="text-[#105840] hover:text-[#0A4A30] underline ml-1 bg-transparent border-none"
//                       >
//                         read more
//                       </button>
//                     )}
//                   </span>
//                 </label>

//                 {acceptError && (
//                   <p className="text-red-500 text-sm">{acceptError}</p>
//                 )}

//                 <motion.button
//                   whileHover={{ scale: 1.02 }}
//                   whileTap={{ scale: 0.98 }}
//                   className="
//               w-full py-3.5 rounded-xl
//               bg-[#105840] hover:bg-[#0A4A30]
//               text-white font-semibold text-lg
//               shadow-lg shadow-[#105840]/30
//               hover:shadow-xl hover:shadow-[#105840]/40
//               transition-all
//               relative overflow-hidden
//               group
//             "
//                   onClick={sendOtp}
//                   disabled={loading}
//                 >
//                   <span className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></span>
//                   {loading ? (
//                     <div className="flex items-center justify-center gap-2">
//                       <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
//                       <span>Sending...</span>
//                     </div>
//                   ) : (
//                     "Send OTP"
//                   )}
//                 </motion.button>
//               </motion.div>
//             ) : (
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.5 }}
//                 className="w-full space-y-5"
//               >
//                 {/* OTP SCREEN */}
//                 <div className="text-center space-y-2">
//                   <p className="text-gray-600">
//                     OTP sent to{" "}
//                     <span className="text-[#105840] font-semibold">
//                       +91 {mobile}
//                     </span>
//                   </p>
//                   <p className="text-sm text-gray-500">
//                     Enter the 4-digit verification code
//                   </p>
//                 </div>

//                 <div className="py-4">
//                   <div className="flex justify-center gap-3">
//                     {[0, 1, 2, 3].map((index) => (
//                       <input
//                         key={index}
//                         type="text"
//                         maxLength={1}
//                         value={otp[index] || ""}
//                         onChange={(e) => {
//                           const value = e.target.value.replace(/\D/g, "");
//                           const newOtp = [...otp];
//                           newOtp[index] = value;
//                           setOtp(newOtp);

//                           // Auto focus next input
//                           if (value && index < 3) {
//                             const nextInput = document.querySelector(
//                               `input[name=otp-${index + 1}]`,
//                             );
//                             if (nextInput) nextInput.focus();
//                           }
//                         }}
//                         onKeyDown={(e) => {
//                           if (
//                             e.key === "Backspace" &&
//                             !otp[index] &&
//                             index > 0
//                           ) {
//                             const prevInput = document.querySelector(
//                               `input[name=otp-${index - 1}]`,
//                             );
//                             if (prevInput) prevInput.focus();
//                           }
//                         }}
//                         name={`otp-${index}`}
//                         placeholder=""
//                         className="w-14 h-14 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 text-2xl text-center focus:border-[#105840] focus:ring-1 focus:ring-[#105840] transition-all outline-none"
//                       />
//                     ))}
//                   </div>
//                 </div>

//                 <motion.button
//                   whileHover={{ scale: 1.02 }}
//                   whileTap={{ scale: 0.98 }}
//                   className="
//               w-full py-3.5 rounded-xl
//               bg-[#105840] hover:bg-[#0A4A30]
//               text-white font-semibold text-lg
//               shadow-lg shadow-[#105840]/30
//               hover:shadow-xl hover:shadow-[#105840]/40
//               transition-all
//               relative overflow-hidden
//               group
//             "
//                   onClick={verifyOTP}
//                   disabled={loading}
//                 >
//                   <span className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></span>
//                   {loading ? (
//                     <div className="flex items-center justify-center gap-2">
//                       <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
//                       <span>Verifying...</span>
//                     </div>
//                   ) : (
//                     "Verify OTP"
//                   )}
//                 </motion.button>

//                 <div className="text-center">
//                   {seconds > 0 ? (
//                     <p className="text-gray-500">
//                       Didn't receive code?{" "}
//                       <span className="text-[#105840] font-medium">
//                         Resend in 00:{seconds}s
//                       </span>
//                     </p>
//                   ) : (
//                     <button
//                       className="text-[#105840] hover:text-[#0A4A30] font-medium transition-colors bg-transparent border-none"
//                       onClick={!loading ? resendOtp : () => {}}
//                     >
//                       Resend OTP
//                     </button>
//                   )}
//                 </div>
//               </motion.div>
//             )}

//             {/* Security Badge */}
//             <motion.div
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               transition={{ delay: 0.8 }}
//               className="mt-6 flex items-center gap-2 text-xs text-gray-400"
//             >
//               <svg
//                 className="w-4 h-4 text-[#105840]"
//                 fill="currentColor"
//                 viewBox="0 0 20 20"
//               >
//                 <path
//                   fillRule="evenodd"
//                   d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
//                   clipRule="evenodd"
//                 />
//               </svg>
//               <span>Secure 256-bit SSL Encryption</span>
//             </motion.div>
//           </div>
//         </motion.div>

//         <style jsx>{`
//           @keyframes float {
//             0%,
//             100% {
//               transform: translateY(0);
//             }
//             50% {
//               transform: translateY(-20px);
//             }
//           }
//           .animate-float {
//             animation: float 6s ease-in-out infinite;
//           }
//         `}</style>
//       </Loginwrapper>
//       {/* <div className="services_page_section" data-aos="zoom-in">
//         <div className="services_row">
//           <Link to="/instant-loan">
//             <div className="services_item">
//               <div className="services_icon_container">
//                 <GiPayMoney className="services_icon" />
//               </div>
//               <div className="services_content">
//                 <div className="services_title">
//                   <h4>Instant Loan</h4>
//                 </div>
//                 <p>
//                   We offer instant loans to help you tackle unexpected financial
//                   needs swiftly and efficiently.
//                 </p>
//               </div>
//             </div>
//           </Link>
//           <Link to="/short-term-loan">
//             <div className="services_item">
//               <div className="services_icon_container">
//                 <GiTakeMyMoney className="services_icon" />
//               </div>
//               <div className="services_content">
//                 <div className="services_title">
//                   <h4>Short Loan</h4>
//                 </div>
//                 <p>
//                   Discover the convenience of short loans at Speedoloan,
//                   designed to meet your immediate financial needs with ease.
//                 </p>
//               </div>
//             </div>
//           </Link>
//           <Link to="/debt-consolidation-loan">
//             <div className="services_item">
//               <div className="services_icon_container">
//                 <VscCombine className="services_icon" />
//               </div>
//               <div className="services_content">
//                 <div className="services_title">
//                   <h4>Debt Consolidation</h4>
//                 </div>
//                 <p>
//                   Take control of your finances with our debt consolidation
//                   services. Consolidate multiple debts into one manageable
//                   payment
//                 </p>
//               </div>
//             </div>
//           </Link>
//         </div>
//       </div> */}

//       {/* 2. Instant Loan Approval */}
//       {/* <div className="max-w-7xl mx-auto px-4 py-8">
//         {[
//           {
//             title: "Instant Loan Approval",
//             description:
//               "Apply and get approved for a loan within minutes. Our automated system ensures that you receive instant decisions based on your profile.",
//             image: "/images/about/about-1.jpg",
//             icon: <GiReceiveMoney className="text-[#4FA0FF] text-3xl" />,
//             bgColor: "bg-blue-50",
//             reverse: false,
//             points: [
//               {
//                 text: "Approval in as little as 5 minutes",
//                 icon: <FaClock className="text-[#4FA0FF] mr-3" />,
//               },
//               {
//                 text: "24/7 application processing",
//                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
//               },
//               {
//                 text: "Real-time status updates",
//                 icon: <FaMobileAlt className="text-[#4FA0FF] mr-3" />,
//               },
//             ],
//           },
//           {
//             title: "100% Digital Process",
//             description:
//               "Experience a paperless journey from start to finish. Upload your documents, verify your details, and get disbursal—all online.",
//             image: "/images/about/about-2.jpg",
//             icon: <GiArchiveResearch className="text-[#4FA0FF] text-3xl" />,
//             bgColor: "bg-indigo-50",
//             reverse: true,
//             points: [
//               {
//                 text: "No physical paperwork required",
//                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
//               },
//               {
//                 text: "eKYC and digital signatures",
//                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
//               },
//               {
//                 text: "Instant document verification",
//                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
//               },
//             ],
//           },
//           {
//             title: "Secure & Trusted",
//             description:
//               "Your data is safe with us. We use industry-grade encryption and privacy standards to keep your information secure at all times.",
//             image: "/images/about/about-3.jpg",
//             icon: <FaShieldAlt className="text-[#4FA0FF] text-3xl" />,
//             bgColor: "bg-purple-50",
//             reverse: false,
//             points: [
//               {
//                 text: "Bank-level security protocols",
//                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
//               },
//               {
//                 text: "Regular security audits",
//                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
//               },
//               {
//                 text: "GDPR compliant data handling",
//                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
//               },
//             ],
//           },
//         ].map((feature, index) => (
//           <section
//             key={index}
//             className={`my-16 ${
//               feature.bgColor
//             } rounded-2xl overflow-hidden flex flex-col ${
//               feature.reverse ? "md:flex-row-reverse" : "md:flex-row"
//             } shadow-sm border border-gray-200 group`}
//           >
//             <div className="flex-1 min-w-[300px] p-8 md:p-12 flex flex-col justify-center">
//               <div className="flex items-center mb-5">
//                 <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-md mr-4">
//                   {feature.icon}
//                 </div>
//                 <h2 className="text-2xl font-bold text-[#1D3557] m-0">
//                   {feature.title}
//                 </h2>
//               </div>
//               <p className="text-gray-600 text-lg leading-relaxed mb-8">
//                 {feature.description}
//               </p>
//               <ul className="list-none p-0 m-0">
//                 {feature.points.map((point, i) => (
//                   <li key={i} className="flex items-center mb-3 text-gray-600">
//                     {point.icon}
//                     {point.text}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//             <div className="flex-1 min-w-[300px] min-h-[400px] relative flex items-center justify-center p-0 overflow-hidden">
//               <div
//                 className={`absolute inset-0 ${
//                   feature.reverse ? "bg-gradient-to-r" : "bg-gradient-to-l"
//                 } from-[#4FA0FF]/5 to-transparent`}
//               ></div>
//               <img
//                 src={feature.image}
//                 alt={feature.title}
//                 className="relative z-10 w-full h-full max-h-[400px] object-cover shadow-lg transition-transform duration-300 group-hover:scale-105  "
//               />
//             </div>
//           </section>
//         ))}
//       </div> */}

//       <div className="max-w-7xl mx-auto px-4 py-12 bg-[#050A18]">
//         {/* === Counter Section === */}
//         <div className="max-w-7xl mx-auto px-4 py-12 bg-[#050A18] text-center">
//           {/* Heading */}

//           <div className="text-3xl md:text-4xl font-bold mb-3">
//             <span className="text-white">Our Achievements</span>
//             <span className="text-[#4FA0FF]"> at a Glance</span>
//           </div>

//           <p className="text-gray-400 mb-10 text-lg">
//             Millions of families trust us. Here's a quick look at our impact.
//           </p>

//           {/* Counters Grid */}
//           <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
//             {[
//               {
//                 target: 15000,
//                 label: "Trusted Families",
//                 symbol: "+",
//                 icon: <FaUsers className="text-[white] text-3xl" />,
//                 points: [
//                   "Over 10 years of experience",
//                   "Millions of happy clients",
//                 ],
//               },
//               {
//                 target: 5000,
//                 label: "Loans Disbursed",
//                 symbol: "+",
//                 icon: <FaMoneyBillWave className="text-[white] text-3xl" />,
//                 points: [
//                   "Fast approval within minutes",
//                   "Flexible repayment options",
//                 ],
//               },
//               {
//                 target: 98,
//                 label: "Customer Satisfaction",
//                 symbol: "%",
//                 icon: <FaSmile className="text-[white] text-3xl" />,
//                 points: [
//                   "24/7 customer support",
//                   "Trusted by thousands nationwide",
//                 ],
//               },
//             ].map((counter, i) => (
//               <div
//                 key={i}
//                 className="bg-[#111827] backdrop-blur-md rounded-2xl p-8 border border-white/20 shadow-lg hover:shadow-blue-300/30 transition flex flex-col items-center justify-center"
//               >
//                 {/* Icon */}
//                 <div className="w-16 h-16 bg-[#1E293B] rounded-full flex items-center justify-center mb-4 shadow-md">
//                   {counter.icon}
//                 </div>

//                 {/* Counter */}
//                 <h3 className="text-4xl font-bold text-[#4FA0FF] flex justify-center items-center gap-1">
//                   <span className="counter" data-target={counter.target}>
//                     0
//                   </span>
//                   <span className="text-[#4FA0FF]">{counter.symbol}</span>
//                 </h3>

//                 {/* Label */}
//                 <p className="mt-2 text-gray-300 text-lg">{counter.label}</p>

//                 {/* Small Points */}
//                 <ul className="mt-3 text-gray-400 text-sm list-disc list-inside space-y-1">
//                   {counter.points.map((point, idx) => (
//                     <li key={idx}>{point}</li>
//                   ))}
//                 </ul>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* === Cards Section === */}
//         {[
//           {
//             title: "Instant Loan Approval",
//             description:
//               "Apply and get approved for a loan within minutes. Our automated system ensures that you receive instant decisions based on your profile.",
//             image: "/images/about/about-1.jpg",
//             icon: <GiReceiveMoney className="text-[#4FA0FF] text-3xl" />,
//             reverse: false,
//             points: [
//               {
//                 text: "Approval in as little as 5 minutes",
//                 icon: <FaClock className="text-[#4FA0FF] mr-3" />,
//               },
//               {
//                 text: "24/7 application processing",
//                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
//               },
//               {
//                 text: "Real-time status updates",
//                 icon: <FaMobileAlt className="text-[#4FA0FF] mr-3" />,
//               },
//             ],
//           },
//           {
//             title: "100% Digital Process",
//             description:
//               "Experience a paperless journey from start to finish. Upload your documents, verify your details, and get disbursal—all online.",
//             image: "/images/about/about-2.jpg",
//             icon: <GiArchiveResearch className="text-[#4FA0FF] text-3xl" />,
//             reverse: true,
//             points: [
//               {
//                 text: "No physical paperwork required",
//                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
//               },
//               {
//                 text: "eKYC and digital signatures",
//                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
//               },
//               {
//                 text: "Instant document verification",
//                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
//               },
//             ],
//           },
//           {
//             title: "Secure & Trusted",
//             description:
//               "Your data is safe with us. We use industry-grade encryption and privacy standards to keep your information secure at all times.",
//             image: "/images/about/about-3.jpg",
//             icon: <FaShieldAlt className="text-[#4FA0FF] text-3xl" />,
//             reverse: false,
//             points: [
//               {
//                 text: "Bank-level security protocols",
//                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
//               },
//               {
//                 text: "Regular security audits",
//                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
//               },
//               {
//                 text: "GDPR compliant data handling",
//                 icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
//               },
//             ],
//           },
//         ].map((feature, index) => (
//           <motion.section
//             key={index}
//             initial={feature.reverse ? "hiddenRight" : "hiddenLeft"}
//             whileInView="visible"
//             viewport={{ once: true, amount: 0.2 }}
//             variants={cardVariants}
//             className={`my-16 rounded-2xl overflow-hidden flex flex-col md:flex-row ${
//               feature.reverse ? "md:flex-row-reverse" : ""
//             } shadow-sm border border-gray-700 bg-[#111827]/70 backdrop-blur-md`}
//           >
//             <div className="flex-1 min-w-[300px] p-8 md:p-12 flex flex-col justify-center">
//               <div className="flex items-center mb-5">
//                 <div className="w-12 h-12 bg-[#1E293B] rounded-lg flex items-center justify-center shadow-md mr-4">
//                   {feature.icon}
//                 </div>
//                 <h2 className="text-2xl font-bold text-white m-0">
//                   {feature.title}
//                 </h2>
//               </div>
//               <p className="text-gray-300 text-lg leading-relaxed mb-8">
//                 {feature.description}
//               </p>
//               <ul className="list-none p-0 m-0">
//                 {feature.points.map((point, i) => (
//                   <li key={i} className="flex items-center mb-3 text-gray-300">
//                     {point.icon}
//                     {point.text}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//             <div className="flex-1 min-w-[300px] min-h-[400px] relative flex items-center justify-center p-0 overflow-hidden">
//               <div
//                 className={`absolute inset-0 ${
//                   feature.reverse ? "bg-gradient-to-r" : "bg-gradient-to-l"
//                 } from-[#4FA0FF]/10 to-transparent`}
//               ></div>
//               <img
//                 src={feature.image}
//                 alt={feature.title}
//                 className="relative z-10 w-full h-full max-h-[400px] object-cover shadow-lg transition-transform duration-300 group-hover:scale-105"
//               />
//             </div>
//           </motion.section>
//         ))}

//         {/* Scroll to Top Button */}
//         {showScroll && (
//           <button
//             onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
//             className="
//       fixed bottom-5 right-3 z-50
//       w-12 h-12 flex items-center justify-center
//       bg-[#105840] text-white text-2xl
//       rounded-full shadow-lg
//       transition-all duration-300
//       border border-white/20
//       backdrop-blur-md
//       animate-fadeIn
//       font-bold
//     "
//           >
//             ↑
//           </button>
//         )}
//       </div>
//     </>
//   );
// }

// export default Login;
import React, { useEffect, useState, useRef } from "react";
import { Loginwrapper } from "../style";
import Input from "../../ui/Input";
import Button from "../../ui/Button";
import OtpInput from "../../OtpInput/OtpInput";
import imgLogin from "../../../images/loginImg.png";
import imgLogin2 from "../../../images/loginBanner.jpg";
import { FaRupeeSign, FaCity } from "react-icons/fa";
import { FaMoneyBillWave, FaSmile } from "react-icons/fa";
import { motion } from "framer-motion";
import rightImage from "../../../images/instant_loan.jpg";
import verificationIcon from "../../../images/banner.png";

import {
  FaRocket,
  FaUsers,
  FaLightbulb,
  FaCheckCircle,
  FaShieldAlt,
  FaMobileAlt,
  FaClock,
  FaArrowRight,
  FaStar,
  FaRegGem,
  FaHandHoldingHeart,
  FaChartLine,
  FaBuilding,
  FaBolt,
  FaLock,
  FaHeadset,
} from "react-icons/fa";
import { GiReceiveMoney, GiArchiveResearch } from "react-icons/gi";
import {
  getStorage,
  isEmpty,
  isNumber,
  setStorage,
  getStoredUTM,
} from "../../../Utils/common";
import { Link, useNavigate } from "react-router-dom";
import {
  sendotpForLogin,
  verifyotpForLogin,
  ckeckEligibility,
} from "../../../Utils/api";
import Alert from "../../ui/Alert";
import MobileInput from "../../OtpInput/MobileInput";

function Login() {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [screen, setScreen] = useState("getOtp");
  const [seconds, setSeconds] = useState(0);
  const [mobile, setMobile] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [loading, setLoading] = useState(false);
  const [accept, setAccept] = useState(false);
  const [acceptError, setAcceptError] = useState("");
  const [message, setMessage] = useState({});
  const [responce, setResponce] = useState({});
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  const [showMore, setShowMore] = useState(false);

  // Extract UTM parameters from the URL
  const getUtmParams = () => {
    const params = new URLSearchParams(window.location.search);
    const utm = getStoredUTM();
    return {
      utm_source:
        params.get("utm_source") || utm?.utm_source || utm?.referrer || "",
      utm_medium: params.get("utm_medium") || utm?.utm_medium || "",
      utm_campaign: params.get("utm_campaign") || utm?.utm_campaign || "",
      utm_term: params.get("utm_term") || utm?.utm_term || "",
      utm_content: params.get("utm_content") || utm?.utm_content || "",
    };
  };

  useEffect(() => {
    if (screen === "getOtp") return;
    const timer = setInterval(() => {
      if (seconds === 0) {
        clearInterval(timer);
      } else {
        setSeconds(seconds - 1);
      }
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [seconds]);

  const sendOtp = () => {
    let mobileNumber = mobile;
    if (mobileNumber.length < 10) {
      setMobileError(
        "The Mobile field must be at least 10 characters in length.",
      );
      return;
    }
    if (!accept) {
      setAcceptError(
        "Please check the checkbox to accept our terms and conditions",
      );
      return;
    } else {
      setAcceptError("");
    }

    // Get UTM parameters from the URL
    const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } =
      getUtmParams();

    const param = {
      mobile: mobileNumber,
      event_name: "login",
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
    };

    setLoading(true);
    sendotpForLogin(param).then((resp) => {
      setLoading(false);
      if (resp?.data?.Status === 1) {
        setResponce(resp?.data);
        setStorage("mobile", mobileNumber);
        setStorage("cust_profile_id", resp?.data?.Data?.cust_profile_id);
        setScreen("otpScreen");
        setSeconds(30);
        setMessage({
          type: "success",
          msg: resp?.data?.Message,
          place: "globle",
        });
      } else {
        setMobile("");
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
        let msg =
          resp?.data?.Message || resp?.data?.error || "An error occurred";
        setMessage({ type: "error", msg: msg });
      }
    });
  };

  const resendOtp = () => {
    const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } =
      getUtmParams();

    const param = {
      profile_id: getStorage("cust_profile_id"),
      event_name: "resend_otp",
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
    };

    setLoading(true);
    sendotpForLogin(param).then((resp) => {
      setLoading(false);
      if (resp?.data?.Status === 1) {
        setResponce(resp?.data);
        setScreen("otpScreen");
        setSeconds(30);
        setMessage({
          type: "success",
          msg: resp?.data?.Message,
          place: "globle",
        });
      } else {
        setMobile("");
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
        let msg =
          resp?.data?.Message || resp?.data?.error || "An error occurred";
        setMessage({ type: "error", msg: msg });
      }
    });
  };

  const verifyOTP = async () => {
    let otpNumber = otp.join("");

    if (otpNumber.length !== 4) {
      setMessage({ type: "error", msg: "Please enter 4 digits OTP" });
      return;
    }

    const param = {
      event_name: "otp_verify",
      profile_id: getStorage("cust_profile_id"),
      otp: otpNumber,
    };

    setLoading(true);
    try {
      const resp = await verifyotpForLogin(param);

      setLoading(false);

      if (resp?.data?.Status === 1) {
        setResponce(resp?.data);
        setStorage("next_step", resp?.data?.Data?.next_step);
        setStorage("token", resp?.data?.Data?.app_login_token);
        setMessage({
          type: "success",
          msg: resp?.data?.Message,
          place: "globle",
        });

        if (resp?.data?.Data?.eligibility_status === 1) {
          setStorage("eligibility", 1);
        } else {
          setStorage("eligibility", 0);
        }

        if (getStorage("eligibility") === 1) {
          navigate("/my-dashboard/eligibility");
        } else {
          navigate("/my-dashboard");
        }
      } else {
        setOtp(["", "", "", ""]);
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
        let msg =
          resp?.data?.Message || resp?.data?.error || "An error occurred";
        setMessage({ type: "error", msg: msg });
      }
    } catch (err) {
      setLoading(false);
      setMessage({ type: "error", msg: "Error verifying OTP" });
      console.error("OTP Verification Error:", err);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      verifyOTP();
    }
  };

  useEffect(() => {
    if (isEmpty(message)) return;
    const timer = setTimeout(() => {
      setMessage({});
    }, 5000);

    return () => {
      clearTimeout(timer);
    };
  }, [message]);

  useEffect(() => {
    const counters = document.querySelectorAll(".counter");
    counters.forEach((counter) => {
      const updateCount = () => {
        const target = +counter.getAttribute("data-target");
        const count = +counter.innerText.replace(/,/g, "");
        const increment = target / 200;
        if (count < target) {
          counter.innerText = Math.ceil(count + increment).toLocaleString();
          setTimeout(updateCount, 20);
        } else {
          counter.innerText = target.toLocaleString();
        }
      };
      updateCount();
    });
  }, []);

  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Animation variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.25, 0.1, 0, 1] },
    },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  // Generate bubbles
  const bubbles = [...Array(15)].map((_, i) => ({
    id: i,
    size: Math.random() * 12 + 4,
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 100}%`,
    delay: i * 0.15,
    duration: Math.random() * 15 + 15,
    opacity: Math.random() * 0.1 + 0.03,
  }));

  return (
    <>
      {/* <Loginwrapper className="relative min-h-screen w-full overflow-hidden bg-gradient-to-b from-white via-[#F8FAF5] to-white"> */}
        {/* Floating Wave Background - Top 
        <div className="absolute top-0 left-0 w-full pointer-events-none">
          <svg
            className="w-full h-48 md:h-64"
            viewBox="0 0 1440 300"
            preserveAspectRatio="none"
          >
            <motion.path
              animate={{
                d: [
                  "M0,150 C300,225 600,75 900,150 C1200,225 1440,75 1440,150 L1440,0 L0,0 Z",
                  "M0,195 C300,120 600,270 900,195 C1200,120 1440,270 1440,195 L1440,0 L0,0 Z",
                  "M0,150 C300,225 600,75 900,150 C1200,225 1440,75 1440,150 L1440,0 L0,0 Z",
                ],
              }}
              transition={{ duration: 12, repeat: Infinity }}
              fill="#105840"
              fillOpacity="0.05"
            />
          </svg>
        </div>

        {/* Floating Wave Background - Middle 
        <div className="absolute inset-0 pointer-events-none">
          <motion.div
            animate={{
              y: [0, -30, 0],
              x: [0, 20, 0],
            }}
            transition={{ duration: 20, repeat: Infinity }}
            className="absolute top-20 left-[5%] w-72 h-72 bg-[#105840]/5 rounded-full blur-3xl"
          />
          <motion.div
            animate={{
              y: [0, 30, 0],
              x: [0, -20, 0],
            }}
            transition={{ duration: 18, repeat: Infinity }}
            className="absolute bottom-20 right-[5%] w-96 h-96 bg-[#105840]/5 rounded-full blur-3xl"
          />
        </div>

        {/* Floating Wave Background - Bottom 
        <div className="absolute bottom-0 left-0 w-full pointer-events-none">
          <svg
            className="w-full h-48 md:h-64 rotate-180"
            viewBox="0 0 1440 300"
            preserveAspectRatio="none"
          >
            <motion.path
              animate={{
                d: [
                  "M0,150 C300,225 600,75 900,150 C1200,225 1440,75 1440,150 L1440,0 L0,0 Z",
                  "M0,195 C300,120 600,270 900,195 C1200,120 1440,270 1440,195 L1440,0 L0,0 Z",
                ],
              }}
              transition={{ duration: 12, repeat: Infinity }}
              fill="#105840"
              fillOpacity="0.05"
            />
          </svg>
        </div>

        {/* Floating Bubbles 
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {bubbles.map((bubble) => (
            <motion.div
              key={bubble.id}
              className="absolute rounded-full bg-[#105840]"
              style={{
                width: bubble.size,
                height: bubble.size,
                left: bubble.left,
                top: bubble.top,
                opacity: bubble.opacity,
              }}
              animate={{
                y: [0, -40, 0, 40, 0],
                x: [0, 30, -30, 20, 0],
              }}
              transition={{
                duration: bubble.duration,
                repeat: Infinity,
                delay: bubble.delay,
                ease: "easeInOut",
              }}
            />
          ))}
        </div>

        {/* Main Content 
        <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 xl:px-16 py-12 md:py-20">
          {/* Hero Section *
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={staggerContainer}
            className="grid lg:grid-cols-2 gap-12 items-center mb-24"
          >
            {/* Left Content 
            <motion.div variants={fadeInUp}>
              {/* Green Line Above Heading */}
              {/* <motion.div
                initial={{ width: 0 }}
                whileInView={{ width: "80px" }}
                transition={{ duration: 0.8 }}
                className="h-1 bg-[#105840] mb-6"
              />

              <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 mb-6 leading-tight">
                <span className="text-gray-900">Instant Loans for</span>{" "}
                <span className="text-[#105840]">Salaried Professionals</span>
              </h1> */}

              {/* Underline Effect 
              <div className="relative inline-block mb-6">
                <span className="text-[#105840] font-semibold text-lg">
                  salary lending
                </span>
                <motion.span
                  initial={{ width: 0 }}
                  whileInView={{ width: "100%" }}
                  transition={{ duration: 0.8, delay: 0.5 }}
                  className="absolute -bottom-2 left-0 w-full h-3 bg-[#105840]/10 rounded-full"
                />
              </div>

              <p className="text-lg text-gray-600 mb-8 leading-relaxed max-w-xl">
                A new standard for short-term credit — transparent, fair, and
                built for the way you work today.
              </p>

              {/* Trust Indicators
              <div className="flex items-center gap-6 mb-8">
                <div className="text-sm text-gray-600">
                  Trusted by salaried professionals across India
                </div>
              </div>

              {/* Feature Pills 
              <div className="flex flex-wrap gap-3">
                {[
                  "5 Min Approval",
                  "Zero Collateral",
                  "Paperless Process",
                  "24/7 Support",
                ].map((feature, i) => (
                  <div
                    key={i}
                    className="px-4 py-2 bg-[#105840]/5 rounded-full text-sm text-[#105840] font-medium border border-[#105840]/10"
                  >
                    {feature}
                  </div>
                ))}
              </div>
            </motion.div>

            {/* Right Content - Login Card 
            <motion.div
              variants={fadeInUp}
              className="bg-white rounded-2xl shadow-xl p-6 md:p-8 border border-gray-100"
            >
              {/* Green Line Above Card Title
              <motion.div
                initial={{ width: 0 }}
                whileInView={{ width: "40px" }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="h-1 bg-[#105840] mb-6"
              />

              <div className="flex items-center gap-2 mb-6">
                <span className="text-sm font-medium text-[#105840] tracking-wider uppercase">
                  Get Started
                </span>
              </div>

              <div className="w-16 h-16 bg-[#105840]/10 rounded-xl flex items-center justify-center mb-6">
                <img
                  src={verificationIcon}
                  alt="verification"
                  className="w-10 h-10 object-contain"
                />
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Apply for Loan
              </h3>
              <p className="text-gray-500 text-sm mb-6">
                Enter your mobile number to continue
              </p>

              <Alert setMessage={setMessage} message={message} />

              {screen === "getOtp" ? (
                <div className="space-y-5">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Mobile Number
                    </label>
                    <div className="relative">
                      <span className="absolute left-4 top-1/2 -translate-y-1/2 text-[#105840] font-medium">
                        +91
                      </span>
                      <input
                        type="tel"
                        value={mobile}
                        onChange={(e) => {
                          const value = e.target.value
                            .replace(/\D/g, "")
                            .slice(0, 10);
                          setMobile(value);
                        }}
                        placeholder="Enter your mobile number"
                        className="w-full pl-16 pr-4 py-3 border border-gray-200 rounded-xl focus:border-[#105840] focus:ring-2 focus:ring-[#105840]/20 transition-all outline-none"
                        maxLength={10}
                      />
                    </div>
                    {mobileError && (
                      <p className="text-red-500 text-sm mt-2">{mobileError}</p>
                    )}
                  </div>

                  <label className="flex items-start gap-3 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={accept}
                      onChange={() => {
                        setAccept(!accept);
                        setAcceptError("");
                      }}
                      className="mt-1 w-4 h-4 rounded border-gray-300 text-[#105840] focus:ring-[#105840]"
                    />
                    <span className="text-sm text-gray-600">
                      I agree to the{" "}
                      <Link
                        to="/termsandconditions"
                        className="text-[#105840] font-medium hover:underline"
                      >
                        Terms
                      </Link>{" "}
                      &{" "}
                      <Link
                        to="/privacypolicy"
                        className="text-[#105840] font-medium hover:underline"
                      >
                        Privacy Policy
                      </Link>
                    </span>
                  </label>

                  {acceptError && (
                    <p className="text-red-500 text-sm">{acceptError}</p>
                  )}

                  <button
                    onClick={sendOtp}
                    disabled={loading}
                    className="w-full py-3.5 bg-[#105840] hover:bg-[#0A4A30] text-white font-semibold rounded-xl transition-all shadow-lg shadow-[#105840]/20 hover:shadow-xl flex items-center justify-center gap-2"
                  >
                    {loading ? (
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    ) : (
                      <>
                        Send OTP
                        <FaArrowRight className="text-sm" />
                      </>
                    )}
                  </button>
                </div>
              ) : (
                <div className="space-y-5">
                  <div className="text-center">
                    <p className="text-gray-600">
                      OTP sent to{" "}
                      <span className="text-[#105840] font-semibold">
                        +91 {mobile}
                      </span>
                    </p>
                    <p className="text-sm text-gray-500 mt-1">
                      Enter 4-digit verification code
                    </p>
                  </div>

                  <div className="flex justify-center gap-3">
                    {[0, 1, 2, 3].map((index) => (
                      <input
                        key={index}
                        type="text"
                        maxLength={1}
                        value={otp[index] || ""}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");
                          const newOtp = [...otp];
                          newOtp[index] = value;
                          setOtp(newOtp);

                          if (value && index < 3) {
                            const nextInput = document.querySelector(
                              `input[name=otp-${index + 1}]`,
                            );
                            if (nextInput) nextInput.focus();
                          }
                        }}
                        onKeyDown={(e) => {
                          if (
                            e.key === "Backspace" &&
                            !otp[index] &&
                            index > 0
                          ) {
                            const prevInput = document.querySelector(
                              `input[name=otp-${index - 1}]`,
                            );
                            if (prevInput) prevInput.focus();
                          }
                        }}
                        name={`otp-${index}`}
                        placeholder="*"
                        className="w-14 h-14 border border-gray-200 rounded-xl text-gray-900 text-2xl text-center focus:border-[#105840] focus:ring-2 focus:ring-[#105840]/20 transition-all outline-none"
                      />
                    ))}
                  </div>

                  <button
                    onClick={verifyOTP}
                    disabled={loading}
                    className="w-full py-3.5 bg-[#105840] hover:bg-[#0A4A30] text-white font-semibold rounded-xl transition-all shadow-lg shadow-[#105840]/20 hover:shadow-xl"
                  >
                    {loading ? (
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto"></div>
                    ) : (
                      "Verify OTP"
                    )}
                  </button>

                  <div className="text-center">
                    {seconds > 0 ? (
                      <p className="text-gray-500">
                        Resend in{" "}
                        <span className="text-[#105840] font-medium">
                          00:{seconds}s
                        </span>
                      </p>
                    ) : (
                      <button
                        onClick={!loading ? resendOtp : () => {}}
                        className="text-[#105840] hover:text-[#0A4A30] font-medium transition-colors"
                      >
                        Resend OTP
                      </button>
                    )}
                  </div>
                </div>
              )}
            </motion.div>
          </motion.div>

          {/* Stats Section
          <motion.section
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={staggerContainer}
            className="relative py-16"
          >
            {/* Green Line Above Heading *
            <motion.div
              initial={{ width: 0 }}
              whileInView={{ width: "80px" }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="h-1 bg-[#105840] mb-6"
            />

            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              <span className="text-gray-900">Our</span>{" "}
              <span className="text-[#105840]">Numbers</span>
            </h2>
            <p className="text-gray-500 text-lg mb-12">
              Trusted by salaried professionals across India
            </p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {[
                { value: "Fast", label: "Loan Disbursal", icon: "💰" },
                { value: "Simple", label: "Digital Process", icon: "👥" },
                { value: "Quick", label: "Approval", icon: "⚡" },
                { value: "Transparent", label: "No Hidden Charges", icon: "⭐" },
              ].map((stat, i) => (
                <motion.div
                  key={i}
                  variants={fadeInUp}
                  whileHover={{ y: -5 }}
                  className="bg-white rounded-xl p-6 text-center shadow-md hover:shadow-lg transition-all border border-gray-100"
                >
                  <div className="text-3xl mb-2">{stat.icon}</div>
                  <div className="text-2xl font-bold text-[#105840] mb-1">
                    {stat.value}
                  </div>
                  <div className="text-sm text-gray-500">{stat.label}</div>
                </motion.div>
              ))}
            </div>
          </motion.section>

          {/* New Features Section - Replaced the 3 cards 
          <motion.section
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={staggerContainer}
            className="relative py-16"
          >
            {/* Green Line Above Heading 
            <motion.div
              initial={{ width: 0 }}
              whileInView={{ width: "80px" }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="h-1 bg-[#105840] mb-6"
            />

            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              <span className="text-gray-900">Why</span>{" "}
              <span className="text-[#105840]">Choose Us</span>
            </h2>
            <p className="text-gray-500 text-lg mb-12">
              Simple, fast, and transparent lending solutions
            </p>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                {
                  icon: <FaBolt className="text-2xl text-[#105840]" />,
                  title: "Lightning Fast",
                  desc: "5 minute approval",
                  color: "from-yellow-400/20 to-yellow-600/20",
                },
                {
                  icon: <FaLock className="text-2xl text-[#105840]" />,
                  title: "Bank Grade Security",
                  desc: "256-bit encryption",
                  color: "from-blue-400/20 to-blue-600/20",
                },
                {
                  icon: (
                    <FaHandHoldingHeart className="text-2xl text-[#105840]" />
                  ),
                  title: "Customer First",
                  desc: "24/7 support",
                  color: "from-green-400/20 to-green-600/20",
                },
                {
                  icon: <FaRegGem className="text-2xl text-[#105840]" />,
                  title: "Zero Collateral",
                  desc: "No security needed",
                  color: "from-purple-400/20 to-purple-600/20",
                },
              ].map((item, i) => (
                <motion.div
                  key={i}
                  variants={fadeInUp}
                  whileHover={{ y: -5, scale: 1.02 }}
                  className={`bg-gradient-to-br ${item.color} rounded-xl p-6 shadow-lg hover:shadow-xl transition-all border border-gray-100`}
                >
                  <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center mb-4 shadow-md">
                    {item.icon}
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-gray-600">{item.desc}</p>
                </motion.div>
              ))}
            </div>
          </motion.section>

          {/* Feature Cards with Images - 3 Sections
          {[
            {
              title: "Instant Loan Approval",
              desc: "Apply and get approved for a loan within minutes. Our automated system ensures instant decisions based on your profile.",
              image: "/images/about/about-1.jpg",
              icon: <GiReceiveMoney className="text-3xl text-[#105840]" />,
              reverse: false,
              points: [
                "Approval in as little as 5 minutes",
                "24/7 application processing",
                "Real-time status updates",
              ],
            },
            {
              title: "100% Digital Process",
              desc: "Experience a paperless journey from start to finish. Upload documents, verify details, and get disbursal—all online.",
              image: "/images/about/about-2.jpg",
              icon: <GiArchiveResearch className="text-3xl text-[#105840]" />,
              reverse: true,
              points: [
                "No physical paperwork required",
                "eKYC and digital signatures",
                "Instant document verification",
              ],
            },
            {
              title: "Secure & Trusted",
              desc: "Your data is safe with us. Industry-grade encryption and privacy standards to keep your information secure.",
              image: "/images/about/about-3.jpg",
              icon: <FaShieldAlt className="text-3xl text-[#105840]" />,
              reverse: false,
              points: [
                "Bank-level security protocols",
                "Regular security audits",
                "Data protection compliance",
              ],
            },
          ].map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: feature.reverse ? 50 : -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8 }}
              className={`mt-16 rounded-2xl overflow-hidden flex flex-col md:flex-row ${
                feature.reverse ? "md:flex-row-reverse" : ""
              } shadow-xl border border-gray-100 bg-white`}
            >
              <div className="flex-1 p-8 md:p-12">
                {/* Green Line Above Card Title 
                <motion.div
                  initial={{ width: 0 }}
                  whileInView={{ width: "40px" }}
                  transition={{ duration: 0.8 }}
                  viewport={{ once: true }}
                  className="h-1 bg-[#105840] mb-4"
                />
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 bg-[#105840]/10 rounded-xl flex items-center justify-center">
                    {feature.icon}
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">
                    {feature.title}
                  </h3>
                </div>
                <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                  {feature.desc}
                </p>
                <ul className="space-y-3">
                  {feature.points.map((point, i) => (
                    <li
                      key={i}
                      className="flex items-center gap-3 text-gray-700"
                    >
                      <div className="w-5 h-5 bg-[#105840]/10 rounded-full flex items-center justify-center">
                        <span className="text-[#105840] text-xs">✓</span>
                      </div>
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex-1 relative min-h-[300px] md:min-h-[400px] overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover transition-transform duration-700 hover:scale-110"
                />
                <div
                  className={`absolute inset-0 bg-gradient-to-${feature.reverse ? "l" : "r"} from-[#105840]/10 to-transparent`}
                ></div>
              </div>
            </motion.div>
          ))}

          {/* New CTA Section - Removed the line above
          <motion.section
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={staggerContainer}
            className="relative py-16"
          >
            <motion.div
              variants={fadeInUp}
              className="bg-gradient-to-r from-[#105840] to-[#0A4A30] rounded-2xl p-8 md:p-12 text-center text-white shadow-xl relative overflow-hidden"
            >
              {/* Decorative Elements 
              <div className="absolute inset-0 opacity-5">
                <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMzAgMzBtMzAtMjBMNTAgMTAgNDAgMjAgMzAgMzAgMjAgNDAgMTAgNTAgMCA2MCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utb3BhY2l0eT0iMC4xIiBzdHJva2Utd2lkdGg9IjEiLz48L3N2Zz4=')] opacity-20"></div>
              </div>

              {/* Floating Elements
              <motion.div
                animate={{
                  y: [0, -10, 0],
                  rotate: [0, 5, -5, 0],
                }}
                transition={{ duration: 4, repeat: Infinity }}
                className="absolute top-10 right-10 w-20 h-20 bg-white/10 rounded-full blur-2xl"
              />
              <motion.div
                animate={{
                  y: [0, 10, 0],
                  rotate: [0, -5, 5, 0],
                }}
                transition={{ duration: 5, repeat: Infinity }}
                className="absolute bottom-10 left-10 w-32 h-32 bg-white/10 rounded-full blur-2xl"
              />

              <h3 className="text-3xl md:text-4xl font-bold mb-4 relative z-10">
                Ready to Get Started?
              </h3>
              <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto relative z-10">
                Join thousands of satisfied customers who trust us for their
                financial needs.
              </p>

              <div className="flex flex-wrap gap-4 justify-center relative z-10">
                <button
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="px-8 py-4 bg-white text-[#105840] font-semibold rounded-xl hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl"
                >
                  Apply Now
                </button>
                <button
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="px-8 py-4 bg-transparent border-2 border-white text-white font-semibold rounded-xl hover:bg-white/10 transition-all"
                >
                  Learn More
                </button>
              </div>

              {/* Trust Badge 
              <div className="flex items-center justify-center gap-6 mt-8 text-white/80 text-sm relative z-10">
                <span className="flex items-center gap-2">
                  <FaCheckCircle className="text-white" />
                  No Hidden Fees
                </span>
                <span className="flex items-center gap-2">
                  <FaCheckCircle className="text-white" />
                  Instant Approval
                </span>
                <span className="flex items-center gap-2">
                  <FaCheckCircle className="text-white" />
                  100% Secure
                </span>
              </div>
            </motion.div>
          </motion.section>
        </div>

        {/* Scroll to Top Button
        {showScroll && (
          <motion.button
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: "spring", stiffness: 200 }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="fixed bottom-5 right-5 z-50 w-12 h-12 flex items-center justify-center bg-[#105840] text-white text-2xl rounded-full shadow-lg hover:bg-[#0A4A30] transition-all"
          >
            ↑
          </motion.button>
        )}
      // </Loginwrapper> */}
      <Loginwrapper className="relative min-h-screen w-full overflow-hidden bg-[#0A1620]">
        {/* Static Background Elements */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-20 left-[5%] w-72 h-72 bg-[#2D5F7A]/10 rounded-full blur-3xl" />
          <div className="absolute bottom-20 right-[5%] w-96 h-96 bg-[#7BC4E0]/10 rounded-full blur-3xl" />
        </div>

        {/* Static Bubbles */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {bubbles.map((bubble) => (
            <div
              key={bubble.id}
              className="absolute rounded-full bg-[#7BC4E0]"
              style={{
                width: bubble.size,
                height: bubble.size,
                left: bubble.left,
                top: bubble.top,
                opacity: bubble.opacity,
              }}
            />
          ))}
        </div>

        {/* Main Content */}
        <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 xl:px-16 py-12 md:py-20">
          {/* Hero Section */}
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-24">
            {/* Left Content */}
            <div>
              {/* Blue Line Above Heading */}
              <div className="w-[80px] h-1 bg-[#7BC4E0] mb-6" />

              <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-6 leading-tight">
                <span className="text-white">Instant Funds for</span>{" "}
                <span className="text-[#7BC4E0]">Salaried Professionals</span>
              </h1>


              <p className="text-lg text-[#CCE6F5] mb-8 leading-relaxed max-w-xl">
                A new standard for short-term credit — transparent, fair, and
                built for the way you work today.
              </p>

              {/* Trust Indicators */}
              <div className="flex items-center gap-6 mb-8">
                <div className="text-sm text-[#8FAFC7]">
                  Trusted by salaried professionals across India
                </div>
              </div>

              {/* Feature Pills */}
              <div className="flex flex-wrap gap-3">
                {[
                  "5 Min Approval",
                  "Zero Collateral",
                  "Paperless Process",
                  "24/7 Support",
                ].map((feature, i) => (
                  <div
                    key={i}
                    className="px-4 py-2 bg-[#2D5F7A]/20 rounded-full text-sm text-[#7BC4E0] font-medium border border-[#2D5F7A]/30"
                  >
                    {feature}
                  </div>
                ))}
              </div>
            </div>

            {/* Right Content - Login Card */}
            <div className="bg-[#1A2F3A] rounded-2xl shadow-xl p-6 md:p-8 border border-[#2D5F7A]/30">
              {/* Blue Line Above Card Title */}
              <div className="w-[40px] h-1 bg-[#7BC4E0] mb-6" />

              <div className="flex items-center gap-2 mb-6">
                <span className="text-sm font-medium text-[#7BC4E0] tracking-wider uppercase">
                  Get Started
                </span>
              </div>

              <div className="w-16 h-16 bg-[#2D5F7A]/20 rounded-xl flex items-center justify-center mb-6">
                <img
                  src={verificationIcon}
                  alt="verification"
                  className="w-10 h-10 object-contain"
                />
              </div>

              <h3 className="text-2xl font-bold text-white mb-2">
                Apply for Instant Funds
              </h3>
              <p className="text-[#8FAFC7] text-sm mb-6">
                Enter your mobile number to continue
              </p>

              <Alert setMessage={setMessage} message={message} />

              {screen === "getOtp" ? (
                <div className="space-y-5">
                  <div>
                    <label className="block text-sm font-medium text-[#CCE6F5] mb-2">
                      Mobile Number
                    </label>
                    <div className="relative">
                      <span className="absolute left-4 top-1/2 -translate-y-1/2 text-[#7BC4E0] font-medium">
                        +91
                      </span>
                      <input
                        type="tel"
                        value={mobile}
                        onChange={(e) => {
                          const value = e.target.value
                            .replace(/\D/g, "")
                            .slice(0, 10);
                          setMobile(value);
                        }}
                        placeholder="Enter your mobile number"
                        className="w-full pl-16 pr-4 py-3 bg-[#0F2128] border border-[#2D5F7A]/30 rounded-xl focus:border-[#7BC4E0] focus:ring-2 focus:ring-[#7BC4E0]/20 transition-all outline-none text-white"
                        maxLength={10}
                      />
                    </div>
                    {mobileError && (
                      <p className="text-red-500 text-sm mt-2">{mobileError}</p>
                    )}
                  </div>

                  <label className="flex items-start gap-3 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={accept}
                      onChange={() => {
                        setAccept(!accept);
                        setAcceptError("");
                      }}
                      className="mt-1 w-4 h-4 rounded border-[#2D5F7A]/30 bg-[#0F2128] text-[#7BC4E0] focus:ring-[#7BC4E0]"
                    />
                    <span className="text-sm text-[#8FAFC7]">
                      I agree to the{" "}
                      <Link
                        to="/termsandconditions"
                        className="text-[#7BC4E0] font-medium hover:underline"
                      >
                        Terms
                      </Link>{" "}
                      &{" "}
                      <Link
                        to="/privacypolicy"
                        className="text-[#7BC4E0] font-medium hover:underline"
                      >
                        Privacy Policy
                      </Link>
                    </span>
                  </label>

                  {acceptError && (
                    <p className="text-red-500 text-sm">{acceptError}</p>
                  )}

                  <button
                    onClick={sendOtp}
                    disabled={loading}
                    className="w-full py-3.5 bg-[#2D5F7A] hover:bg-[#1E3B4A] text-white font-semibold rounded-xl transition-all shadow-lg shadow-[#2D5F7A]/20 hover:shadow-xl flex items-center justify-center gap-2"
                  >
                    {loading ? (
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    ) : (
                      <>
                        Send OTP
                        <FaArrowRight className="text-sm" />
                      </>
                    )}
                  </button>
                </div>
              ) : (
                <div className="space-y-5">
                  <div className="text-center">
                    <p className="text-[#CCE6F5]">
                      OTP sent to{" "}
                      <span className="text-[#7BC4E0] font-semibold">
                        +91 {mobile}
                      </span>
                    </p>
                    <p className="text-sm text-[#8FAFC7] mt-1">
                      Enter 4-digit verification code
                    </p>
                  </div>

                  <div className="flex justify-center gap-3">
                    {[0, 1, 2, 3].map((index) => (
                      <input
                        key={index}
                        type="text"
                        maxLength={1}
                        value={otp[index] || ""}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");
                          const newOtp = [...otp];
                          newOtp[index] = value;
                          setOtp(newOtp);

                          if (value && index < 3) {
                            const nextInput = document.querySelector(
                              `input[name=otp-${index + 1}]`,
                            );
                            if (nextInput) nextInput.focus();
                          }
                        }}
                        onKeyDown={(e) => {
                          if (
                            e.key === "Backspace" &&
                            !otp[index] &&
                            index > 0
                          ) {
                            const prevInput = document.querySelector(
                              `input[name=otp-${index - 1}]`,
                            );
                            if (prevInput) prevInput.focus();
                          }
                        }}
                        name={`otp-${index}`}
                        placeholder="*"
                        className="w-14 h-14 bg-[#0F2128] border border-[#2D5F7A]/30 rounded-xl text-white text-2xl text-center focus:border-[#7BC4E0] focus:ring-2 focus:ring-[#7BC4E0]/20 transition-all outline-none"
                      />
                    ))}
                  </div>

                  <button
                    onClick={verifyOTP}
                    disabled={loading}
                    className="w-full py-3.5 bg-[#2D5F7A] hover:bg-[#1E3B4A] text-white font-semibold rounded-xl transition-all shadow-lg shadow-[#2D5F7A]/20 hover:shadow-xl"
                  >
                    {loading ? (
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto"></div>
                    ) : (
                      "Verify OTP"
                    )}
                  </button>

                  <div className="text-center">
                    {seconds > 0 ? (
                      <p className="text-[#8FAFC7]">
                        Resend in{" "}
                        <span className="text-[#7BC4E0] font-medium">
                          00:{seconds}s
                        </span>
                      </p>
                    ) : (
                      <button
                        onClick={!loading ? resendOtp : () => {}}
                        className="text-[#7BC4E0] hover:text-[#2D5F7A] font-medium transition-colors"
                      >
                        Resend OTP
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Stats Section */}
          <section className="relative py-16">
            {/* Blue Line Above Heading */}
            <div className="w-[80px] h-1 bg-[#7BC4E0] mb-6" />

            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              <span className="text-white">Our</span>{" "}
              <span className="text-[#7BC4E0]">Numbers</span>
            </h2>
            <p className="text-[#8FAFC7] text-lg mb-12">
              Trusted by salaried professionals across India
            </p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {[
                { value: "Fast", label: "Get Funds", icon: "💰" },
                { value: "Simple", label: "Digital Process", icon: "👥" },
                { value: "Secure", label: "Data Protection", icon: "⚡" },
                { value: "Transparent", label: "No Hidden Charges", icon: "⭐" },
              ].map((stat, i) => (
                <div
                  key={i}
                  className="bg-[#1A2F3A] rounded-xl p-6 text-center shadow-md hover:shadow-lg transition-all border border-[#2D5F7A]/30"
                >
                  <div className="text-3xl mb-2">{stat.icon}</div>
                  <div className="text-2xl font-bold text-[#7BC4E0] mb-1">
                    {stat.value}
                  </div>
                  <div className="text-sm text-[#8FAFC7]">{stat.label}</div>
                </div>
              ))}
            </div>
          </section>

          {/* New Features Section */}
          <section className="relative py-16">
            {/* Blue Line Above Heading */}
            <div className="w-[80px] h-1 bg-[#7BC4E0] mb-6" />

            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              <span className="text-white">Why</span>{" "}
              <span className="text-[#7BC4E0]">Choose Us</span>
            </h2>
            <p className="text-[#8FAFC7] text-lg mb-12">
              Simple, fast, and transparent lending solutions
            </p>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                {
                  icon: <FaBolt className="text-2xl text-[#7BC4E0]" />,
                  title: "Lightning Fast",
                  desc: "5 minute approval",
                  color: "from-[#2D5F7A]/20 to-[#1E3B4A]/20",
                },
                {
                  icon: <FaLock className="text-2xl text-[#7BC4E0]" />,
                  title: "Bank Grade Security",
                  desc: "256-bit encryption",
                  color: "from-[#2D5F7A]/20 to-[#1E3B4A]/20",
                },
                {
                  icon: <FaHandHoldingHeart className="text-2xl text-[#7BC4E0]" />,
                  title: "Customer First",
                  desc: "24/7 support",
                  color: "from-[#2D5F7A]/20 to-[#1E3B4A]/20",
                },
                {
                  icon: <FaRegGem className="text-2xl text-[#7BC4E0]" />,
                  title: "Zero Collateral",
                  desc: "No security needed",
                  color: "from-[#2D5F7A]/20 to-[#1E3B4A]/20",
                },
              ].map((item, i) => (
                <div
                  key={i}
                  className={`bg-gradient-to-br ${item.color} rounded-xl p-6 shadow-lg hover:shadow-xl transition-all border border-[#2D5F7A]/30`}
                >
                  <div className="w-12 h-12 bg-[#0F2128] rounded-lg flex items-center justify-center mb-4 shadow-md">
                    {item.icon}
                  </div>
                  <h3 className="text-lg font-bold text-white mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-[#8FAFC7]">{item.desc}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Feature Cards with Images - 3 Sections */}
          {[
            {
              title: "Instant Funds Approval",
              desc: "Apply and get approved for instant funds within minutes. Our automated system ensures instant decisions based on your profile.",
              image: "/images/about/about-1.jpg",
              icon: <GiReceiveMoney className="text-3xl text-[#7BC4E0]" />,
              reverse: false,
              points: [
                "Approval in as little as 5 minutes",
                "24/7 application processing",
                "Real-time status updates",
              ],
            },
            {
              title: "100% Digital Process",
              desc: "Experience a paperless journey from start to finish. Upload documents, verify details, and get disbursal—all online.",
              image: "/images/about/about-2.jpg",
              icon: <GiArchiveResearch className="text-3xl text-[#7BC4E0]" />,
              reverse: true,
              points: [
                "No physical paperwork required",
                "eKYC and digital signatures",
                "Instant document verification",
              ],
            },
            {
              title: "Secure & Trusted",
              desc: "Your data is safe with us. Industry-grade encryption and privacy standards to keep your information secure.",
              image: "/images/about/about-3.jpg",
              icon: <FaShieldAlt className="text-3xl text-[#7BC4E0]" />,
              reverse: false,
              points: [
                "Bank-level security protocols",
                "Regular security audits",
                "Data protection compliance",
              ],
            },
          ].map((feature, index) => (
            <div
              key={index}
              className={`mt-16 rounded-2xl overflow-hidden flex flex-col md:flex-row ${
                feature.reverse ? "md:flex-row-reverse" : ""
              } shadow-xl border border-[#2D5F7A]/30 bg-[#1A2F3A]`}
            >
              <div className="flex-1 p-8 md:p-12">
                {/* Blue Line Above Card Title */}
                <div className="w-[40px] h-1 bg-[#7BC4E0] mb-4" />
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 bg-[#0F2128] rounded-xl flex items-center justify-center">
                    {feature.icon}
                  </div>
                  <h3 className="text-2xl font-bold text-white">
                    {feature.title}
                  </h3>
                </div>
                <p className="text-[#CCE6F5] text-lg mb-6 leading-relaxed">
                  {feature.desc}
                </p>
                <ul className="space-y-3">
                  {feature.points.map((point, i) => (
                    <li
                      key={i}
                      className="flex items-center gap-3 text-[#CCE6F5]"
                    >
                      <div className="w-5 h-5 bg-[#2D5F7A]/30 rounded-full flex items-center justify-center">
                        <span className="text-[#7BC4E0] text-xs">✓</span>
                      </div>
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex-1 relative min-h-[300px] md:min-h-[400px] overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover"
                />
                <div
                  className={`absolute inset-0 bg-gradient-to-${feature.reverse ? "l" : "r"} from-[#2D5F7A]/30 to-transparent`}
                ></div>
              </div>
            </div>
          ))}

          {/* New CTA Section */}
          <section className="relative py-16">
            <div className="bg-gradient-to-r from-[#2D5F7A] to-[#1E3B4A] rounded-2xl p-8 md:p-12 text-center text-white shadow-xl relative overflow-hidden">
              {/* Decorative Elements */}
              <div className="absolute inset-0 opacity-5">
                <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMzAgMzBtMzAtMjBMNTAgMTAgNDAgMjAgMzAgMzAgMjAgNDAgMTAgNTAgMCA2MCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utb3BhY2l0eT0iMC4xIiBzdHJva2Utd2lkdGg9IjEiLz48L3N2Zz4=')] opacity-20"></div>
              </div>

              {/* Static Elements */}
              <div className="absolute top-10 right-10 w-20 h-20 bg-white/10 rounded-full blur-2xl" />
              <div className="absolute bottom-10 left-10 w-32 h-32 bg-white/10 rounded-full blur-2xl" />

              <h3 className="text-3xl md:text-4xl font-bold mb-4 relative z-10">
                Ready to Get Started?
              </h3>
              <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto relative z-10">
                Join thousands of satisfied customers who trust us for their
                financial needs.
              </p>

              <div className="flex flex-wrap gap-4 justify-center relative z-10">
                <button
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="px-8 py-4 bg-white text-[#2D5F7A] font-semibold rounded-xl hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl"
                >
                  Apply Now
                </button>
                <button
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="px-8 py-4 bg-transparent border-2 border-white text-white font-semibold rounded-xl hover:bg-white/10 transition-all"
                >
                  Learn More
                </button>
              </div>

              {/* Trust Badge */}
              <div className="flex items-center justify-center gap-6 mt-8 text-white/80 text-sm relative z-10">
                <span className="flex items-center gap-2">
                  <FaCheckCircle className="text-white" />
                  No Hidden Fees
                </span>
                <span className="flex items-center gap-2">
                  <FaCheckCircle className="text-white" />
                  Instant Approval
                </span>
                <span className="flex items-center gap-2">
                  <FaCheckCircle className="text-white" />
                  100% Secure
                </span>
              </div>
            </div>
          </section>
        </div>

        {/* Scroll to Top Button */}
        {showScroll && (
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="fixed bottom-5 right-5 z-50 w-12 h-12 flex items-center justify-center bg-[#2D5F7A] text-white text-2xl rounded-full shadow-lg hover:bg-[#1E3B4A] transition-all"
          >
            ↑
          </button>
        )}
      </Loginwrapper>
    </>
  );
}

export default Login;
